import CardTable from 'components/CardTable/CardTable'
import { useOpenComponent } from 'hooks/useOpenComponent'
import React, { useCallback, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import AddIcon from '@mui/icons-material/Add';
import { GlobalBox } from 'components/Box/GlobalBox';
import { Autocomplete, Box, Card, Grid, TextField, Typography } from '@mui/material';
import { columns } from './columns'
import TableChart from '@mui/icons-material/TableChart'
import RegularButton from 'components/CustomButtons/Button'
import { useSearch } from 'hooks/useSearch'
import { ModalV2 } from 'components/Modal/ModalV2'
import { FormTabulatorEdit } from './FormTabulatorEdit'
import {
  changeContractSelected,
  changeContractVariantSelected, 
  getAllContracts,
  getAllRules,
  resetContractSelected,
  resetContractVariantSelected
} from 'redux/actions/contractsCatalog/contractsCatalogActions';
import {
  addTabulatorMode,
  clearTabulators,
  deleteTabulatorMode,
  editTabulatorMode,
  getTabulators,
  resetTabulatorSelected,
  tabulatorSelected
} from 'redux/actions/tabulatorsCatalog/tabulatorsCatalogActions';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { ColumnContainer } from 'utils/columnsStyle';
import { tabulatorStyles } from './styles';
import { red } from '@mui/material/colors';
import { PERMISSIONS } from 'router/permissions';

const style = {
  color: '#004F9F',
  fontSize: 20,
  marginRight: 10,
  cursor: 'pointer'
}

export const TabulatorsCatalog = () => {
  const { 
    changeStation, 
    setSnackbar,
    clearSearch
  } = useSearch();

  const { token, rules } = useSelector(state => state.login)
  const { tabulatorsArr, addMode, deleteMode } = useSelector(state => state.tabulatorsCatalog)
  const { rulesArr, contractsArr, activeContractVariantsArr, contractSelected, contractVariantSelected } = useSelector(state => state.contractsCatalog)
  const { stationsSelected, isLoading } = useSelector((state) => state.search);
  const { stationsList } = useSelector(state => state.companies);
  const classes = tabulatorStyles();
  const { isOpen, handleIsOpen } = useOpenComponent()
  const [mapTabulators, setTabulators] = useState([])
  const [allColumns, setAllColumns] = useState(columns)
  const [rulesKeysOptions, setRulesKeysOptions] = useState([])
  const [submitted, setSubmitted] = useState(false)
  const [showStatus, setShowStatus] = useState(false)
  const [rulesCombinations, setRulesCombinations] = useState([[]])
  const [allRulesCombinations, setAllRulesCombinations] = useState([[]])
  const { PREPAYROLL_ADMIN } = PERMISSIONS;

  const dispatch = useDispatch()

  const handleChangeStations = useCallback((e, item) => {
    if(item) changeStation(item)
    else changeStation([])
  }, [])

  const handleChangeContracts = useCallback((e, item) => {
    if(item?.value) dispatch(changeContractSelected(item.value))
    else dispatch(resetContractSelected())
  }, [])

  const handleChangeContractVariants = useCallback((e, item) => {
    if(item?.value) dispatch(changeContractVariantSelected(item.value))
    else dispatch(resetContractVariantSelected())
  }, [])
  
  const handleSubmit = useCallback(() => {
    if (stationsSelected.length < 1) {
      setSnackbar("No se ha seleccionado alguna planta.");
      return;
    }

    if(!contractSelected) {
      setSnackbar("No se ha seleccionado algun contrato.");
      return;
    }

    if(!contractVariantSelected) {
      setSnackbar("No se ha seleccionado alguna variante de contrato.");
      return;
    }

    dispatch(getTabulators(token, contractVariantSelected.id));
    setSubmitted(true);
  }, [token, stationsSelected, contractSelected, contractVariantSelected]);

  const handleClose = useCallback(() => {
    dispatch(resetTabulatorSelected())
    handleIsOpen()
  }, [handleIsOpen])

  const handleOpenAdd = useCallback(() => {
    dispatch(addTabulatorMode())
    handleIsOpen()
  }, [handleIsOpen])

  // Effects
  useEffect(() => {
    dispatch(clearTabulators())
    setSubmitted(false)
    setShowStatus(false)
    // eslint-disable-next-line
  }, [stationsSelected, contractSelected, contractVariantSelected])

  useEffect(() => {handleChangeContracts()}, [stationsSelected])

  useEffect(() => {handleChangeContractVariants()}, [contractSelected])

  useEffect(() => {
    dispatch(clearTabulators())
    clearSearch()
  }, [])

  useEffect(() => {
    if(contractVariantSelected) {
      let newRulesArr = rulesArr
      let customerRules = []
      if(contractVariantSelected.rules) {
        contractVariantSelected.rules.forEach(rule => {
          if(rule.function === 'CUSTOMER') {
            newRulesArr = newRulesArr.map(ruleObj => {
              if(ruleObj.type === 'CUSTOMER') {
                customerRules.push({
                  idRule: rule.idRule,
                  value: 'NO APLICA', 
                  idRuleKey: 'NO_APLICA_CUSTOMER'
                })
                return {...ruleObj, ruleKeys: [...ruleObj.ruleKeys, {
                  id: rule.idRuleKey, 
                  value: rule.value.split('%')[0]
                }, {
                  id: 'NO_APLICA_CUSTOMER',
                  value: 'NO_APLICA'
                }].filter((value, index, self) => index === self.findIndex((item) => item.value === value.value))}
              }
              else return ruleObj
            })
          } else if(rule.function === 'CUSTOMER_TYPE') {
            newRulesArr = newRulesArr.map(ruleObj => {
              if(ruleObj.type === 'CUSTOMER_TYPE') {
                customerRules.push({
                  idRule: rule.idRule,
                  value: 'NO APLICA', 
                  idRuleKey: 'NO_APLICA_CUSTOMER_TYPE'
                })
                return {...ruleObj, ruleKeys: [...ruleObj.ruleKeys, {
                  id: 'NO_APLICA_CUSTOMER_TYPE',
                  value: 'NO_APLICA'
                }].filter((value, index, self) => index === self.findIndex((item) => item.value === value.value))}
              }
              else return ruleObj
            })
          }
        })
        customerRules = customerRules.filter((value, index, self) => index === self.findIndex((item) => item.idRuleKey === value.idRuleKey))
      }

      const newTabulators = tabulatorsArr?.map(tabulator => {
        tabulator.idGroups.forEach(id => newRulesArr.forEach(rule => rule.ruleKeys.forEach(ruleKey => { 
          if(ruleKey.id === id) tabulator[rule.id] = ruleKey 
        })))
        return {
          ...tabulator,
          modal: handleIsOpen,
        }
      }).flat().map(tabulatorWithRules => {
        customerRules.forEach(rule => {
          if(!tabulatorWithRules[rule.idRule]) {
            tabulatorWithRules[rule.idRule] = {id: rule.idRuleKey, value: rule.value}
            tabulatorWithRules.idGroups.push(rule.idRuleKey)
          }
        })
        if(tabulatorWithRules.idGroups) tabulatorWithRules.idGroups.sort()
        return tabulatorWithRules
      })
      setTabulators(newTabulators)
    } else setTabulators([])
    // eslint-disable-next-line
  }, [tabulatorsArr])

  useEffect(() => {
    let newColumns = contractVariantSelected?.rules ? contractVariantSelected.rules.reduce((acc, curr) => {
      if(!acc[curr.idRule]) acc[curr.idRule] = []
      
      if(acc[curr.idRule].filter(rule => rule.idRuleKey === curr.idRuleKey).length === 0) {
        if(curr.function === 'CUSTOMER') {
          acc[curr.idRule].push({...curr, value: curr.value.split('%')[0]})
          if(!acc[curr.idRule].find(ruleKey => ruleKey.idRuleKey === 'NO_APLICA_CUSTOMER')) 
            acc[curr.idRule].push({...curr, value: 'NO APLICA', idRuleKey: 'NO_APLICA_CUSTOMER'})
        } else if(curr.function === 'CUSTOMER_TYPE') {
          acc[curr.idRule].push(curr)
          if(!acc[curr.idRule].find(ruleKey => ruleKey.idRuleKey === 'NO_APLICA_CUSTOMER_TYPE')) 
            acc[curr.idRule].push({...curr, value: 'NO APLICA', idRuleKey: 'NO_APLICA_CUSTOMER_TYPE'})
        } else acc[curr.idRule].push(curr)
      }

      return acc
    }, {}) : {}

    let options = Object.keys(newColumns).map(idRule => newColumns[idRule].map(ruleKey => ruleKey.idRuleKey)).reduce((prev, curr) => {
      let newAccumulator = [];
      prev.forEach(prevArray => {
        curr.forEach(currValue => {
          newAccumulator.push(prevArray.concat(currValue).sort());
        });
      });
      return newAccumulator;
    }, [[]]);

    setAllRulesCombinations(options)
    options = options.filter(option => !mapTabulators.find(tabulator => tabulator.idGroups.toString() === option.toString()))
    setRulesCombinations(options)

    newColumns = Object.keys(newColumns).map(idRule => {
      const rule = rulesArr.filter(rule => rule.id === idRule)[0]
      return {
        ...rule,
        ruleKeys: newColumns[idRule]
      }
    })

    setRulesKeysOptions(newColumns)
    const actions = {
      Header: "Acciones",
      filterable: false,
      sortable: false,
      Cell: ({ original }) => {
        const openEdit = () => {
          dispatch(editTabulatorMode())
          original.modal()
          dispatch(tabulatorSelected(original))
        }
        const openEliminate = () => {
          dispatch(deleteTabulatorMode())
          original.modal()
          dispatch(tabulatorSelected(original))
        }
        return (
          <ColumnContainer>
            <EditIcon style={style} onClick={openEdit}/>
            <DeleteIcon style={{ ...style,  color: '#e83737'}} onClick={openEliminate}/>
          </ColumnContainer>
        )
      },
    }

    newColumns = [...columns, ...newColumns.map(column => ({
        Header: column.name,
        accessor: column.id + ".value",
        filterable: true,
        filterMethod: (filter, row) => row[`${column.id}.value`]?.toLowerCase().includes(filter.value.toLowerCase())
    })), ...(rules.includes(PREPAYROLL_ADMIN) ? [actions] : [])]

    setAllColumns(newColumns)
    if(submitted) setTimeout(() => setShowStatus(true),100)
    // eslint-disable-next-line
  }, [mapTabulators])

  useEffect(() => {
    dispatch(getAllContracts(token));
    if(rulesArr.length === 0) dispatch(getAllRules(token))
    // eslint-disable-next-line
  }, [token])

  return (
    <React.Fragment>
      <GlobalBox icon={<TableChart />} title="Catalogo de Tabuladores">
        <Grid container spacing={2} sx={{marginTop: 2}}>
          <Grid item xs={12} sm={12} md={3.3} lg={3.3} xl={3.3}>    
            <Autocomplete
              size="small"
              filterSelectedOptions
              options={stationsList}
              getOptionLabel={(station) => station.label}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="station"
                  value={stationsSelected}
                  label="Buscar por plantas"
                  variant="outlined"
                  size="small"
                />
              )}
              fullWidth
              onChange={(e, v) => handleChangeStations(e, v)}
              noOptionsText={"No hay resultados"}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={3.3} lg={3.3} xl={3.3}>
            <Autocomplete
              size="small"
              key={stationsSelected?.id}
              filterSelectedOptions
              options={contractsArr.filter(contract => contract.idStation === stationsSelected?.id)}
              getOptionLabel={(contract) => contract.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="contract"
                  value={contractSelected}
                  label="Buscar por contrato"
                  variant="outlined"
                  size="small"
                />
              )}
              fullWidth
              onChange={(e, v) => handleChangeContracts(e, v)}
              noOptionsText={"No hay resultados"}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={3.3} lg={3.3} xl={3.3}>    
            <Autocomplete
              size="small"
              key={contractSelected?.id}
              filterSelectedOptions
              options={activeContractVariantsArr}
              getOptionLabel={(variant) => `${variant.job} ${variant.unitType}`}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="variant"
                  value={contractVariantSelected}
                  label="Buscar por variante"
                  variant="outlined"
                  size="small"
                />
              )}
              fullWidth
              onChange={(e, v) => handleChangeContractVariants(e, v)}
              noOptionsText={"No hay resultados"}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
            <RegularButton onClick={handleSubmit} color='info' style={{height: '100%', margin: 0}} fullWidth>Buscar</RegularButton>
          </Grid>
        </Grid>
        {
          showStatus
          ? <Card className={`${classes.border} `}>                  
            <Box className={ `${classes.box} ${classes[
              (allRulesCombinations[0].length && !rulesCombinations.length)
              || (!allRulesCombinations[0].length && mapTabulators.length)
                ? 'good'
                : 'bad'
            ]}`}>
              <Typography variant='h6' className={classes.heading}>Tabuladores:  {
                !allRulesCombinations[0].length && mapTabulators.length 
                  ? '1 de 1'
                  : !allRulesCombinations[0].length && !mapTabulators.length
                    ? '0 de 1'
                    : allRulesCombinations.length === rulesCombinations.length && mapTabulators.length
                      ? <span style={{color: red[500]}}>Existe una discrepancia en el número de tabuladores y sus reglas</span>
                      : `${allRulesCombinations.length - rulesCombinations.length} de ${allRulesCombinations.length}`
              }</Typography>
              {
                rules.includes(PREPAYROLL_ADMIN)
                ? <RegularButton 
                    disabled={Boolean(
                      (!allRulesCombinations[0].length && mapTabulators.length)
                      || (allRulesCombinations[0].length && !rulesCombinations.length)
                    )} 
                    round 
                    justIcon 
                    color="info" 
                    style={{ margin: 10 }} 
                    onClick={handleOpenAdd}
                  >
                    <AddIcon style={{ margin: 0 }}/>
                  </RegularButton>
                : null
              }
            </Box>
          </Card>
          : null
        }
        <CardTable
          data={mapTabulators}
          columns={allColumns}
          loading={isLoading}
          blockBtn
        />
      </GlobalBox>

      <ModalV2
        open={isOpen}
        onClose={handleClose}
        toRight
        title={  
          addMode
          ? 'Agregar nuevo tabulador'
          : deleteMode ? '¿Estas seguro de eliminar este tabulador?'
          : 'Modificar tabulador'
        }
      >
        <FormTabulatorEdit rulesCombinations={rulesCombinations} rulesKeysOptions={rulesKeysOptions} handleClose={handleClose}/>
      </ModalV2>
    </React.Fragment>
  )
}
